module.exports = __webpack_public_path__ + "6a845677ee227ef03e5c023a68d669e3.svg";